"use strict";
import { dbFS, dbFB, functions } from "@/components/firebase.js";
const alertDefaultDuration = 3000;

export default {
  state: {
    alerts: [],
    newUserAdded: null,
    endProceso: false,
    collections: ["firmas", "data-inmuebles", "co-propietarios"],
    burbujaPropietarios: [],
    burbujaPropietariosNo: [],
    dialogAdminPropietariosEdit: false,
    nuevoPropietarioEnBurbuja: null
  },
  getters: {
    nuevoPropietarioEnBurbuja: state => {
      return state.nuevoPropietarioEnBurbuja;
    },
    dialogAdminPropietariosEdit: state => {
      return state.dialogAdminPropietariosEdit;
    },
    burbujaPropietarios: state => {
      return state.burbujaPropietarios;
    },
    burbujaPropietariosNo: state => {
      return state.burbujaPropietariosNo;
    },
    endProceso: state => {
      return state.endProceso;
    },
    newUserAdded: state => {
      return state.newUserAdded;
    },
    alertsRegister: state => {
      let result = state.alerts;
      const positions = [
        "b-left",
        "b-center",
        "b-right",
        "t-left",
        "t-center",
        "t-right"
      ];
      let i = 0;
      let index = 0;
      result.forEach(() => {
        if (i > positions.length - 1) {
          i = 0;
        }
        result[index].y = i > 2 ? "top" : "bottom";
        result[index].x =
          i === 0 || i === 3 ? "left" : i === 2 || i === 5 ? "right" : "";
        i++;
      });
      return state.alerts;
    }
  },
  mutations: {
    burbujaPropietariosReset: state => {
      state.burbujaPropietarios = [];
    },
    burbujaPropietariosNoReset: state => {
      state.burbujaPropietariosNo = [];
    },
    burbujaPropietariosPush: (state, payload) => {
      let data = payload;
      state.collections.forEach(nameCol => {
        data[nameCol] = [];
      });
      state.burbujaPropietarios.push(data);
      state.nuevoPropietarioEnBurbuja = payload.uid;
    },
    burbujaPropietariosNoPush: (state, payload) => {
      state.burbujaPropietariosNo.push(payload);
    },
    burbujaPropietariosSubCollection: (state, payload) => {
      /* const index = state.burbujaPropietarios.filter((o, i) => {
        if (o.uid === payload.uid) {
          return i;
        }
      })[0]; */
      let index = -1;
      state.burbujaPropietarios.forEach((o, i) => {
        if (o.uid === payload.uid) {
          index = i;
        }
      });
      if (!index) {
        return;
      }
      state.burbujaPropietarios[index][payload.collection] = payload.datos;
    },
    newAlerts: (state, payload) => {
      const timer = new Date().getTime();
      const duration = payload.duration
        ? payload.duration
        : alertDefaultDuration;
      const data = {
        id: timer,
        type: payload.type,
        text: payload.text
      };
      state.alerts.push(data);
      setTimeout(() => {
        for (let index = 0; index < state.alerts.length; index++) {
          const element = state.alerts[index];
          if (element.id === timer) {
            state.alerts.splice(index, 1);
            break;
          }
        }
      }, duration);
    },
    newUserAdded: (state, payload) => {
      state.newUserAdded = payload;
    },
    endProceso: state => {
      state.endProceso = true;
      setTimeout(() => {
        state.endProceso = false;
      }, 1000);
    },
    setDialogAdminPropietariosEdit: (state, payload) => {
      state.dialogAdminPropietariosEdit = payload;
    }
  },
  actions: {
    setDialogAdminPropietariosEdit: ({ commit }, payload) => {
      commit("setDialogAdminPropietariosEdit", payload);
    },
    buscaNuevoUserAdded: ({ rootState, commit }, id) => {
      const user = rootState.users[id] || null;
      // eslint-disable-next-line no-console
      console.log("user: ", user);
      commit("newUserAdded", user);
      commit("endProceso");
    },
    addNewUserCatastro: ({ commit, dispatch }, payload) => {
      const altaUser = functions.httpsCallable("addNewUserCatastro");
      altaUser(payload)
        .then(data => {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(data));
          if (data.data.success) {
            dispatch("buscaNuevoUserAdded", data.data.userId);
          } else {
            commit("endProceso");
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
          commit("endProceso");
        });
    },
    newAlerts: ({ commit }, payload) => {
      commit("newAlerts", payload);
    },

    sendLinkForms: ({ commit }, payload) => {
      const sendLink = functions.httpsCallable("sendLinkFormsUser");
      const nombre = payload.nombre;
      // const sendLink = functions.httpsCallable("addMessage");
      sendLink(payload)
        .then(data => {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(data));
          const alert = {
            type: data.data.success ? "success" : "error",
            text: data.data.success
              ? `Link enviado satisfactoriamente a ${nombre}`
              : `A ocurrido un error enviado link a ${nombre}`,
            duration: 3000
          };
          commit("newAlerts", alert);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    sendLinkRegister: ({ commit }, payload) => {
      const sendLink = functions.httpsCallable("sendLinkRegisterUser");
      const nombre = payload.nombre;
      // const sendLink = functions.httpsCallable("addMessage");
      sendLink(payload)
        .then(data => {
          // eslint-disable-next-line no-console
          console.log(JSON.stringify(data));
          const alert = {
            type: data.data.success ? "success" : "error",
            text: data.data.success
              ? `Link enviado satisfactoriamente a ${nombre}`
              : `A ocurrido un error enviado link a ${nombre}`,
            duration: 3000
          };
          commit("newAlerts", alert);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    checkPropietarios: ({ commit, dispatch }, payload) => {
      if (!payload || payload.length < 0) {
        return null;
      }
      commit("burbujaPropietariosReset"); // Vacía el array de propietarios en la burbuja
      commit("burbujaPropietariosNoReset");
      payload.forEach(uid => {
        dbFS
          .collection("users-pre")
          .doc(uid)
          .get()
          .then(doc => {
            if (!doc.exists) {
              // eslint-disable-next-line no-console
              console.log(`No existe el usuario ${uid} ****`);
              commit("burbujaPropietariosNoPush", uid);
            } else {
              commit("burbujaPropietariosPush", doc.data());
              dispatch("checkPropietariosCollections", uid);
            }
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
      });
    },
    checkPropietariosCollections: ({ state, commit }, payload) => {
      const uid = payload;
      const namesCollections = state.collections;
      // Check firmas
      namesCollections.forEach(nameCol => {
        dbFS
          .collection("users-pre")
          .doc(uid)
          .collection(nameCol)
          .get()
          .then(querySnapshot => {
            let result = [];
            querySnapshot.forEach(doc => {
              result.push(doc.data());
            });
            if (result.length > 0) {
              commit("burbujaPropietariosSubCollection", {
                uid: uid,
                collection: nameCol,
                datos: result
              });
            }
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
      });
    }
  }
};
